import { createShopperBirthDateForPayment } from '@makemydeal/dr-common-utils';
import type { Offer, Shopper } from '@makemydeal/dr-platform-types';
import { SPACE_DELIMITER } from '../constants/meta';
import { coBuyerSuffixToProperCase } from '../utils/coBuyerUtils';
import { isBirthMonthValid } from './helpers';
import { getCoBuyerInfo, getShopperInfo } from './offerNodeSelectors';
import { getShopperCommonConsumerId } from './topLevelSelectors';
import type { OfferReduxBaseState } from '../types/offerReduxBaseState';

/**
 * @deprecated Please use getShopperCommonConsumerId instead
 */
export const getCommonConsumerId = (state: any): string => getShopperCommonConsumerId(state);

export const getCoBuyerCommonConsumerId = (state: any): string => {
    const coBuyer = getCoBuyerInfo(state);
    return coBuyer?.commonConsumerId as string;
};

export const getCoBuyerFullName = (state: Offer): string | undefined => {
    const coBuyer = getCoBuyerInfo(state);
    if (coBuyer == null) return undefined;
    const coBuyerSuffix = coBuyerSuffixToProperCase(coBuyer.suffix);
    return [coBuyer.firstName, coBuyer.middleName, coBuyer.lastName, coBuyerSuffix].filter(Boolean).join(SPACE_DELIMITER);
};

/**
 * Returns true if co-buyer is present on the offer AND the co-buyer has a commonConsumerId
 */
export const hasCoBuyer = (state: OfferReduxBaseState): boolean => {
    const coBuyer = getCoBuyerInfo(state);
    if (coBuyer == null) return false;
    return Boolean(coBuyer.commonConsumerId?.length);
};

export function getShopperZip(state: OfferReduxBaseState) {
    const shopper = getShopperInfo(state);
    return shopper.zip;
}

export function getShopper(state: OfferReduxBaseState): Shopper {
    const shopper = getShopperInfo(state);
    return {
        city: shopper.city,
        state: shopper.state,
        streetAddress: `${shopper.streetAddress || ''} ${shopper.streetAddress2 || ''}`.trim(),
        zip: shopper.zip,
        lastName: shopper.lastName,
        birthDate: isBirthMonthValid(shopper.birthDate) ? createShopperBirthDateForPayment(shopper.birthDate!) : undefined
    };
}

export const getIsShopperInfoMissed = (state: OfferReduxBaseState): boolean => {
    const shopper = getShopperInfo(state);
    return !shopper || !shopper.lastName;
};
